import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/customer-contracts/create'
)({
  meta: () => [{ title: MENU.NEW_REGISTRATION }],
  beforeLoad: ({ context: { auth } }) => {
    if (auth?.user?.type !== USER_TYPE.OWNER) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}/settings/customer-contracts`
      })
    }
  },
  loader: async ({ context: { auth } }) => {
    return {
      authUser: auth.user
    }
  }
})
